/** Frontend pages the PDF exporter renders headless; they load without a client session or cookie banner. */
export enum EPdfPrintRoute {
  REPORT = 'pdf-print',
  PERFORMANCE_ASSESSMENT_ENTRY = 'pae-pdf-print',
  TEMPLATE_SET = 'template-set-pdf-print',
  SUPPORT_MEASURE_REPORT = 'support-measure-pdf-print',
}
